'use strict'
/**
 * ValidationMixin
 * バリデーション処理を一括して管理するMixin
 */

/**
 * メールアドレスのバリデーション
 * @param String mailaddress メールアドレス
 */
function validMailaddress (mailaddress) {
  let res = {
    isValid: true,
    errors: {
      mailaddress: null
    }
  }
  try {
    if (mailaddress !== null && mailaddress !== undefined && mailaddress.length > 0) {
      if (!this._isMailaddress(mailaddress)) {
        res.isValid = false
        res.errors.mailaddress = this.$i18n.t('InvalidMsg.ERR_001')
      } else if (!this._isMaxSize(mailaddress, 254)) {
        res.isValid = false
        res.errors.mailaddress = this.$i18n.t('InvalidMsg.ERR_002')
      }
    }
  } catch (ex) {
    res.isValid = false
    console.error(ex)
    window.commonAlert(this.$i18n.t('ErrorMsg.ERR_999'))
  }
  return res
}

/**
 * クレジットカードのバリデーション
 * @param Object card 入力したカードの券面情報
 * @param Object limitYear 有効期限（年）の選択肢
 */
function validCreditCard (card, limitYears) {
  let res = {
    isValid: true,
    errors: {
      number: null,
      month: null,
      year: null,
      secureCode: null
    }
  }
  try {
    // 券面番号
    if (!this._isRequired(card.number)) {
      res.isValid = false
      res.errors.number = this.$i18n.t('InvalidMsg.ERR_011')
    } else if (!this._isMaxSize(card.number, 16)) {
      res.isValid = false
      res.errors.number = this.$i18n.t('InvalidMsg.ERR_012')
    } else if (!this._isNumber(card.number, true)) {
      res.isValid = false
      res.errors.number = this.$i18n.t('InvalidMsg.ERR_012')
    }
    // 有効期限（月）
    if (!this._isRequired(card.month)) {
      res.isValid = false
      res.errors.month = this.$i18n.t('InvalidMsg.ERR_021')
    } else if (!this._isSize(card.month, 2)) {
      res.isValid = false
      res.errors.month = this.$i18n.t('InvalidMsg.ERR_022')
    } else if (!this._isNumber(card.month, true)) {
      res.isValid = false
      res.errors.month = this.$i18n.t('InvalidMsg.ERR_022')
    } else if (!this._isRange(card.month, 1, 12)) {
      res.isValid = false
      res.errors.month = this.$i18n.t('InvalidMsg.ERR_022')
    }
    // 有効期限（年）
    if (!this._isRequired(card.year)) {
      res.isValid = false
      res.errors.year = this.$i18n.t('InvalidMsg.ERR_031')
    } else if (!this._isSize(card.year, 4)) {
      res.isValid = false
      res.errors.year = this.$i18n.t('InvalidMsg.ERR_032')
    } else if (!this._isNumber(card.year, true)) {
      res.isValid = false
      res.errors.year = this.$i18n.t('InvalidMsg.ERR_032')
    } else if (!this._isRange(card.year, limitYears[0], limitYears[limitYears.length - 1])) {
      res.isValid = false
      res.errors.year = this.$i18n.t('InvalidMsg.ERR_032')
    }
    // セキュリティコード
    if (!this._isRequired(card.secureCode)) {
      res.isValid = false
      res.errors.secureCode = this.$i18n.t('InvalidMsg.ERR_041')
    } else if (!this._isSize(card.secureCode, 3) && !this._isSize(card.secureCode, 4)) {
      res.isValid = false
      res.errors.secureCode = this.$i18n.t('InvalidMsg.ERR_042')
    } else if (!this._isNumber(card.secureCode, true)) {
      res.isValid = false
      res.errors.secureCode = this.$i18n.t('InvalidMsg.ERR_042')
    }
  } catch (ex) {
    res.isValid = false
    console.error(ex)
    window.commonAlert(this.$i18n.t('ErrorMsg.ERR_999'))
  }
  return res
}

/**
 * マイファーストカードのバリデーション
 * @param Object card 入力したカードの券面情報
 * @param Number ownershipPoint 所持ポイント
 * @param Number discountablePoint ポイント割引可能金額
 * @param boolean canNotUsePoint ポイント利用不可フラグ
  */
function validMyFirstCard (card, ownershipPoint, discountablePoint, canNotUsePoint) {
  let res = {
    isValid: true,
    errors: {
      number: null,
      pin: null,
      point: null
    }
  }
  let maxPoint = 0
  try {
    // ポイントの上限額を決定する
    // ポイント割引可能金額が0の場合はポイントの上限額は0になる
    // （10%クーポンを併用or全ての商品が割引禁止商品のため）
    if (!canNotUsePoint) {
      // 所持ポイント、ポイント割引可能金額の少ない方を最大ポイント額としてセットする
      if (ownershipPoint > discountablePoint) {
        maxPoint = discountablePoint
      } else {
        maxPoint = ownershipPoint
      }
    }

    // 券面番号
    // 4つのセグメントに分かれているため、連結してから評価をする
    let number = ''
    if (card.number.segment1 !== null && card.number.segment1.length > 0) {
      number = number.concat(card.number.segment1)
    }
    if (card.number.segment2 !== null && card.number.segment2.length > 0) {
      number = number.concat(card.number.segment2)
    }
    if (card.number.segment3 !== null && card.number.segment3.length > 0) {
      number = number.concat(card.number.segment3)
    }
    if (card.number.segment4 !== null && card.number.segment4.length > 0) {
      number = number.concat(card.number.segment4)
    }

    if (!this._isRequired(number)) {
      res.isValid = false
      res.errors.number = this.$i18n.t('InvalidMsg.ERR_051')
    } else if (!this._isSize(number, 16)) {
      res.isValid = false
      res.errors.number = this.$i18n.t('InvalidMsg.ERR_052')
    } else if (!this._isNumber(number, true)) {
      res.isValid = false
      res.errors.number = this.$i18n.t('InvalidMsg.ERR_052')
    }
    // PINコード
    if (!this._isRequired(card.pin)) {
      res.isValid = false
      res.errors.pin = this.$i18n.t('InvalidMsg.ERR_061')
    } else if (!this._isSize(card.pin, 6)) {
      res.isValid = false
      res.errors.pin = this.$i18n.t('InvalidMsg.ERR_062')
    } else if (!this._isNumber(card.pin, true)) {
      res.isValid = false
      res.errors.pin = this.$i18n.t('InvalidMsg.ERR_062')
    }
    // ポイント
    if (card.point !== null && card.point !== undefined && card.point.length > 0) {
      if (canNotUsePoint) {
        // ポイントを利用できない場合
        if (!this._isRange(card.point, 0, 0)) {
          res.isValid = false
          res.errors.point = this.$i18n.t('InvalidMsg.ERR_074')
        }
      } else {
        // ポイントを利用できる場合
        if (!this._isNumber(card.point, true)) {
          res.isValid = false
          res.errors.point = this.$i18n.t('InvalidMsg.ERR_071')
        } else if (!this._isRange(card.point, 0, maxPoint)) {
          res.isValid = false
          res.errors.point = `${this.$i18n.t('InvalidMsg.ERR_072')}${maxPoint}${this.$i18n.t('InvalidMsg.ERR_073')}`
        }
      }
    }
  } catch (ex) {
    res.isValid = false
    console.error(ex)
    window.commonAlert(this.$i18n.t('ErrorMsg.ERR_999'))
  }
  return res
}

// 個数のバリデーション
function validQuantity (value) {
  let res = {
    isValid: true,
    errors: {
      quantity: null
    }
  }
  try {
    if (!this._isRequired(value)) {
      res.isValid = false
      res.errors.quantity = this.$i18n.t('InvalidMsg.ERR_081')
    } else if (!this._isRange(value, 1, 99)) {
      res.isValid = false
      res.errors.quantity = this.$i18n.t('InvalidMsg.ERR_082')
    }
  } catch (ex) {
    res.isValid = false
    console.error(ex)
    window.commonAlert(this.$i18n.t('ErrorMsg.ERR_999'))
  }
  return res
}

/**
 * メールログインのバリデーション
 * @param {*} mailaddress
 * @param {*} password
 */
function validMailLogin (mailaddress, password) {
  let res = {
    isValid: true,
    errors: {
      mailaddress: null,
      password: null
    }
  }
  try {
    // メールアドレスのバリデーション
    if (!this._isRequired(mailaddress)) {
      res.isValid = false
      res.errors.mailaddress = this.$i18n.t('InvalidMsg.ERR_001')
    } else if (!this._isMailaddress(mailaddress)) {
      res.isValid = false
      res.errors.mailaddress = this.$i18n.t('InvalidMsg.ERR_001')
    } else if (!this._isMaxSize(mailaddress, 254)) {
      res.isValid = false
      res.errors.mailaddress = this.$i18n.t('InvalidMsg.ERR_002')
    }

    // パスワードのバリデーション
    if (!this._isRequired(password)) {
      res.isValid = false
      res.errors.password = this.$i18n.t('InvalidMsg.ERR_091')
    }
  } catch (ex) {
    res.isValid = false
    console.error(ex)
    window.commonAlert(this.$i18n.t('ErrorMsg.ERR_999'))
  }
  return res
}

/**
 * ２段階認証のバリデーション
 * @param {*} mailaddress
 * @param {*} password
 */
function valid2PhaseLogin (authcode) {
  let res = {
    isValid: true,
    errors: {
      authcode: null
    }
  }
  try {
    // 認証コードのバリデーション
    if (!this._isRequired(authcode)) {
      res.isValid = false
      res.errors.authcode = this.$i18n.t('InvalidMsg.ERR_111')
    }
  } catch (ex) {
    res.isValid = false
    console.error(ex)
    window.commonAlert(this.$i18n.t('ErrorMsg.ERR_999'))
  }
  return res
}

/**
 * テーブル番号のバリデーション
 * @param {*} tableNumber
 */
function validTableNumber (tableNumber) {
  let res = {
    isValid: true,
    errors: {
      tableNumber: null
    }
  }
  try {
    if (!this._isRequired(tableNumber)) {
      res.isValid = false
      res.errors.tableNumber = this.$i18n.t('InvalidMsg.ERR_101')
    } else if (!this._isSize(tableNumber, 3)) {
      res.isValid = false
      res.errors.tableNumber = this.$i18n.t('InvalidMsg.ERR_102')
    } else if (!this._isNumber(tableNumber)) {
      res.isValid = false
      res.errors.tableNumber = this.$i18n.t('InvalidMsg.ERR_102')
    }
  } catch (ex) {
    res.isValid = false
    console.error(ex)
    window.commonAlert(this.$i18n.t('ErrorMsg.ERR_999'))
  }
  return res
}

// 必須
function _isRequired (value) {
  // 全ての型においてnull, undefinedをチェック
  if (value === null || value === undefined) {
    return false
  }
  // 文字列型のみ字数をチェック
  switch (typeof value) {
    case 'string':
    case 'number':
      if (value.length === 0) {
        return false
      }
      break
    default:
      break
  }
  return true
}

// 数字（0フィルを許容する場合としない場合で正規表現を変更する）
function _isNumber (value) {
  // 数字以外が含まれていたらfalseとする
  if (!(value).match('^[0-9]+$')) {
    return false
  }
  return true
}

// 桁数（指定桁数のみ許容）
function _isSize (value, size) {
  if (value.length !== size) {
    return false
  }
  return true
}

// 最大桁数
function _isMaxSize (value, size) {
  if (value.length > size) {
    return false
  }
  return true
}

// 数値の範囲（最小値、最大値）
function _isRange (value, min, max) {
  // nullやundefinedが渡されたら0とみなす
  if (value === null || value === undefined) {
    value = 0
  }
  if (Number(value) < Number(min)) {
    return false
  } else if (Number(value) > Number(max)) {
    return false
  }
  return true
}

// メールアドレス（暫定版）
function _isMailaddress (value) {
  if (!value.match('^[a-zA-Z0-9+._-]+\\@[a-zA-Z0-9+._-]+\\.[a-z]+$')) {
    return false
  }
  return true
}

export default {
  data () {
    return {}
  },
  methods: {
    validCreditCard,
    validMyFirstCard,
    validMailaddress,
    validQuantity,
    validMailLogin,
    valid2PhaseLogin,
    validTableNumber,
    _isRequired,
    _isNumber,
    _isSize,
    _isRange,
    _isMailaddress,
    _isMaxSize
  }
}



// WEBPACK FOOTER //
// ./src/mixins/ValidationMixin.js